export const getMathObjectArray = (array: any[], key: string): number => {
  if (!array.length || array.some((item) => item[key] === undefined)) {
    throw new Error("Invalid input in getMathObjectArray");
  }
  return Math.max.apply(
    null,
    array.map((item) => item[key]),
  );
};
